module.exports = __webpack_public_path__ + "static/img/picture5.1ff5b02b.png";